var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",style:(_vm.rootStyles)},[_c('img',{attrs:{"src":require("@/assets/img/orca_logo_white.svg"),"height":"20"}}),_c('span',[_vm._v("labs")])])
}
var staticRenderFns = []

export { render, staticRenderFns }